import React, { useEffect, useState } from "react";

import icon from "../../assets/images/brand/logo_2_107x70.png";
import style from "../forgotPassword/forgotPassword.module.css";
import Input from "../../components/Input";
import smsGif from "../../assets/images/gif/sms.gif";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import axios from "axios";
import { _axios } from "../../utils/axios";
const ForgotPassword = () => {

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [existingLogo, setExistingLogo] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch logo
        const logoResponse = await _axios.get(`${BASE_URL}/api/logo`);
        if (logoResponse.data.success === 1) {
          setLogoUrl(logoResponse.data.url);
          if (logoResponse.data.filename) {
            setExistingLogo(logoResponse.data.filename);
          }
        }
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, []);

  const handleNext = () => {
    if (step < 2) {
      /**
       * BEFORE — email and mobile were both required:
       *   if (email.length === 0 || mobile.length === 0) {
       *     ErrorToast("Please Enter Valid Email and Mobile Number")
       *     return
       *   }
       *   ...
       *   if (isNaN(Number(email)) && !isValid) { ... }
       *   _axios.post(`${BASE_URL}/api/forgot-password/sent`, { email, mobile })
       *
       * Email is optional at account creation, so only the mobile number is
       * required; the reset link always goes by SMS. A typed email must still
       * be valid, and a blank one is sent as null.
       */
      if (mobile.length === 0) {
        ErrorToast("Please enter valid mobile number")
        return
      }
      if (!isNaN(Number(mobile)) && mobile.length < 10) {
        ErrorToast("Please enter valid mobile number")
        return
      }
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      const isValid = emailRegex.test(email);
      if (email.trim().length > 0 && isNaN(Number(email)) && !isValid) {
        ErrorToast("Please enter valid email")
        return
      }
      _axios.post(`${BASE_URL}/api/forgot-password/sent`, { email: email.trim() ? email : null, mobile })
        .then(function (details) {
          console.log('response', details)
          SuccessToast('Reset password email sent successfully')
        }).catch(function (error) {
          // handle error
          console.log(error);
        })

      setStep(step + 1);

    }
    else alert("Submitted successfully");
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  return (
    <div>
      <div className={style.loginContainer}>
        <div className={style.loginForm}>
          <div className={style.logo}>
            {logoUrl && (
              <img
                src={logoUrl}
                alt="Logo"
                className={style.companyIcon}
              />
            )}
          </div>

          {step === 1 && (
            <>
              <div className={style.loginText}>Forgot Password</div>

              <br />

              <Input
                title={"Mobile Number"}
                isRequired
                placeholder={"Mobile Number"}
                isIcon={true}
                type="tel"
                onChange={e => setMobile(e.target.value)}
              />

              {/* BEFORE — title={"Email"} isRequired placeholder={"Email"}; email is optional now */}
              <Input
                title={"Email (Optional)"}
                placeholder={"Email (Optional)"}
                isIcon={true}
                icon={"fa fa-envelope"}
                type="text"
                onChange={e => setEmail(e.target.value)}
              />

              <button onClick={handleNext} className={style.sendButton}>Send</button>

            </>
          )}
          {step === 2 && (
            <>
              <img src={smsGif} alt="Logo" className={style.smsGif} />

              {/* BEFORE — always "Password Reset link share on your Email {email} ... check your Inbox" */}
              {email.trim() ? (
                <h6 className={style.desc}>
                  Password Reset link share on your <br /> Email {email} <br />
                  Please check your Inbox for reset <br /> password
                </h6>
              ) : (
                <h6 className={style.desc}>
                  Password Reset link share on your <br /> Mobile Number {mobile} <br />
                  Please check your SMS for reset <br /> password
                </h6>
              )}

            </>
          )}

        </div>
      </div>
      );
    </div>
  );
};

export default ForgotPassword;
